document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('[data-main-image]');
  const thumbs = gallery.querySelectorAll('[data-thumb]');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.image;
      thumbs.forEach((item) => item.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
});

function getVariantsFromPicker(picker) {
  const json = picker.querySelector('[data-variant-json]');
  if (!json) return [];
  try {
    return JSON.parse(json.textContent || '[]');
  } catch (e) {
    console.warn('Variant JSON parse error:', e);
    return [];
  }
}

function getSelectedOptions(picker) {
  const groups = [...picker.querySelectorAll('[data-option-group]')];
  return groups.map((g) => {
    const selected = g.querySelector('[data-option-value].selected');
    return selected ? selected.dataset.optionValue : null;
  });
}

function updateOptionAvailability(picker) {
  const variants = getVariantsFromPicker(picker);
  if (!variants.length) return;

  const groups = [...picker.querySelectorAll('[data-option-group]')];

  groups.forEach((group, groupIndex) => {
    group.querySelectorAll('[data-option-value]').forEach((btn) => {
      const value = btn.dataset.optionValue;
      // Um valor só fica desabilitado se estiver realmente esgotado em TODAS as
      // combinações onde aparece - não só porque não combina com a cor/tamanho
      // selecionado agora (isso o clique resolve sozinho trocando o outro grupo).
      const matchingVariants = variants.filter((variant) => variant.options[groupIndex] === value);
      const unavailable = matchingVariants.length === 0; // Removed availability check to force adding to cart
      btn.classList.toggle('unavailable', unavailable);
      btn.disabled = unavailable;
    });
  });
}

function updateVariant(picker) {
  const buyBox = picker.closest('.buy-box');
  const form = buyBox?.querySelector('form[action*="/cart/add"]');
  const variantInput = form?.querySelector('[data-variant-id]');
  const addButton = form?.querySelector('[data-add-to-cart]');
  const priceDisplay = buyBox?.querySelector('[data-price]');
  const comparePriceDisplay = buyBox?.querySelector('[data-compare-price]');

  const variants = getVariantsFromPicker(picker);
  if (!variantInput || !variants.length) return;

  const selectedOptions = getSelectedOptions(picker);

  // Se alguma opção não estiver selecionada, não consegue encontrar variante
  if (selectedOptions.some((opt) => opt === null)) {
    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Bitte wählen...';
    }
    return;
  }

  const matchedVariant = variants.find((variant) => {
    return selectedOptions.every((value, index) => variant.options[index] === value);
  });

  if (!matchedVariant) {
    if (addButton) {
      addButton.disabled = true;
      addButton.textContent = 'Nicht verfügbar';
    }
    return;
  }

  variantInput.value = matchedVariant.id;

  if (addButton) {
    addButton.disabled = false; // Forced to always be active
    addButton.textContent = 'In den Warenkorb';
  }

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  // Atualiza preço exibido
  if (priceDisplay && matchedVariant.price) {
    priceDisplay.textContent = formatter.format(matchedVariant.price / 100);
  }

  // Atualiza preço comparado (se houver)
  if (comparePriceDisplay && matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
    comparePriceDisplay.textContent = formatter.format(matchedVariant.compare_at_price / 100);
    comparePriceDisplay.style.display = '';
  } else if (comparePriceDisplay) {
    comparePriceDisplay.style.display = 'none';
  }
}

// Garante que ao menos um valor esteja selecionado em cada grupo na inicialização
function ensureDefaultSelection(picker) {
  const groups = [...picker.querySelectorAll('[data-option-group]')];
  groups.forEach((group) => {
    const hasSelected = group.querySelector('[data-option-value].selected');
    if (!hasSelected) {
      const firstAvailable = group.querySelector('[data-option-value]:not(.unavailable):not([disabled])');
      if (firstAvailable) {
        firstAvailable.classList.add('selected');
      } else {
        // Se nenhum disponível, pega o primeiro
        const first = group.querySelector('[data-option-value]');
        if (first) first.classList.add('selected');
      }
    }
  });

  // Atualiza labels
  groups.forEach((group) => {
    const selected = group.querySelector('[data-option-value].selected');
    if (selected) {
      const position = selected.dataset.optionPosition;
      const label = picker.querySelector(`[data-option-label="${position}"]`);
      if (label) label.textContent = selected.dataset.optionValue;
    }
  });
}

document.querySelectorAll('[data-option-value]').forEach((button) => {
  button.addEventListener('click', () => {
    const picker = button.closest('[data-variant-picker]');
    const group = button.closest('[data-option-group]');
    const label = picker?.querySelector(`[data-option-label="${button.dataset.optionPosition}"]`);
    const mainImage = document.querySelector('[data-main-image]');

    // Botão disabled não deve ser clicável, mas garantimos dupla verificação
    if (button.disabled) return;

    group?.querySelectorAll('[data-option-value]').forEach((item) => item.classList.remove('selected'));
    button.classList.add('selected');

    if (label) label.textContent = button.dataset.optionValue;
    if (mainImage && button.dataset.image) mainImage.src = button.dataset.image;

    if (picker) {
      const variants = getVariantsFromPicker(picker);
      const groups = [...picker.querySelectorAll('[data-option-group]')];
      const selected = getSelectedOptions(picker);
      const clickedPosition = Number(button.dataset.optionPosition);

      // Verifica se a combinação atual existe
      const isValidCombo = variants.some((variant) =>
        selected.every((value, index) => value !== null && variant.options[index] === value)
      );

      // Se a combinação não for válida, tenta encontrar um fallback
      if (!isValidCombo && variants.length) {
        // Encontra o primeiro variant que tenha o valor clicado na posição clicada
        const fallback = variants.find((variant) =>
          variant.options[clickedPosition - 1] === button.dataset.optionValue
        );

        if (fallback) {
          groups.forEach((otherGroup, index) => {
            if (index === clickedPosition - 1) return;
            const value = fallback.options[index];
            otherGroup.querySelectorAll('[data-option-value]').forEach((item) => {
              item.classList.toggle('selected', item.dataset.optionValue === value);
            });
            const otherLabel = picker.querySelector(`[data-option-label="${index + 1}"]`);
            if (otherLabel) otherLabel.textContent = value;
          });
        }
      }

      // Atualiza disponibilidade e variante
      updateOptionAvailability(picker);
      updateVariant(picker);
    }
  });
});

document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
  ensureDefaultSelection(picker);
  updateOptionAvailability(picker);
  updateVariant(picker);
});

// ============ Fallback: garante que o variant ID esteja atualizado antes do submit ============
document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', function (e) {
    const picker = this.closest('.buy-box')?.querySelector('[data-variant-picker]');
    if (picker) {
      updateVariant(picker); // Garante que o ID está atualizado antes de enviar
    }
  });
});

document.querySelectorAll('[data-color]').forEach((button) => {
  button.addEventListener('click', () => {
    const label = document.querySelector('[data-color-label]');
    const mainImage = document.querySelector('[data-main-image]');
    document.querySelectorAll('[data-color]').forEach((item) => item.classList.remove('selected'));
    button.classList.add('selected');
    if (label) label.textContent = button.dataset.color;
    if (mainImage && button.dataset.image) mainImage.src = button.dataset.image;
  });
});

document.querySelectorAll('[data-size]').forEach((button) => {
  button.addEventListener('click', () => {
    const label = document.querySelector('[data-size-label]');
    document.querySelectorAll('[data-size]').forEach((item) => item.classList.remove('selected'));
    button.classList.add('selected');
    if (label) label.textContent = button.dataset.size;
  });
});

// ============ Cookie Consent ============
(() => {
  const STORAGE_KEY = 'ccn_cookie_consent';
  const banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;

  const getConsent = () => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  };

  const setConsent = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // localStorage unavailable (private browsing) - consent just won't persist across reloads
    }
    banner.hidden = true;
    window.dispatchEvent(new CustomEvent('cookieconsentchange', { detail: { consent: value } }));
  };

  if (!getConsent()) banner.hidden = false;

  banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => setConsent('all'));
  banner.querySelector('[data-cookie-essential]')?.addEventListener('click', () => setConsent('essential'));

  document.querySelectorAll('[data-cookie-settings]').forEach((button) => {
    button.addEventListener('click', () => {
      banner.hidden = false;
    });
  });

  window.CatsCozyConsent = {
    get: getConsent,
    hasAnalyticsConsent: () => getConsent() === 'all',
  };
})();

// ============ Consent-gated tracking scripts ============
(() => {
  const tracking = window.CatsCozyTracking;
  if (!tracking) return;

  let ga4Loaded = false;
  let fbLoaded = false;

  const loadGA4 = (id) => {
    if (ga4Loaded || !id) return;
    ga4Loaded = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { dataLayer.push(arguments); };
    gtag('js', new Date());
    gtag('config', id, { anonymize_ip: true });
  };

  const loadFBPixel = (id) => {
    if (fbLoaded || !id) return;
    fbLoaded = true;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    fbq('init', id);
    fbq('track', 'PageView');
  };

  const maybeLoadTracking = () => {
    if (window.CatsCozyConsent?.hasAnalyticsConsent()) {
      loadGA4(tracking.ga4Id);
      loadFBPixel(tracking.fbPixelId);
    }
  };

  maybeLoadTracking();
  window.addEventListener('cookieconsentchange', maybeLoadTracking);
})();

// ============ Tracking Events ============
function trackAddToCart(variantId, price, quantity) {
  if (typeof fbq === 'function') {
    fbq('track', 'AddToCart', {
      content_ids: [variantId],
      content_type: 'product',
      value: price,
      currency: 'EUR',
    });
  }
  if (typeof gtag === 'function') {
    gtag('event', 'add_to_cart', {
      currency: 'EUR',
      value: price,
      items: [{ id: variantId, quantity: quantity }],
    });
  }
}

function trackPurchase(orderId, value) {
  if (typeof fbq === 'function') {
    fbq('track', 'Purchase', {
      value: value,
      currency: 'EUR',
    });
  }
  if (typeof gtag === 'function') {
    gtag('event', 'purchase', {
      transaction_id: orderId,
      value: value,
      currency: 'EUR',
    });
  }
}

document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
  btn.addEventListener('click', function () {
    const form = this.closest('form');
    const priceEl = form?.closest('.buy-box')?.querySelector('.price-row strong');
    let price = 0;
    if (priceEl) {
      price = parseFloat(priceEl.textContent.replace(/[^0-9,.]/g, '').replace(',', '.')) || 0;
    }
    const variantInput = form?.querySelector('[data-variant-id]');
    if (variantInput) {
      trackAddToCart(variantInput.value, price, 1);
    }
  });
});

// ============ Exit-Intent Popup ============
(() => {
  const popup = document.querySelector('[data-exit-popup]');
  if (!popup) return;

  const STORAGE_KEY = 'ccn_exit_popup_shown';
  let hasShown = false;

  const hasSeenPopup = () => {
    try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
  };

  const markSeen = () => {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch {}
  };

  const showPopup = () => {
    if (hasShown || hasSeenPopup()) return;
    hasShown = true;
    popup.classList.add('open');
    markSeen();
  };

  const hidePopup = () => {
    popup.classList.remove('open');
  };

  // Close button
  popup.querySelector('[data-exit-popup-close]')?.addEventListener('click', hidePopup);

  // Click outside to close
  popup.addEventListener('click', (e) => {
    if (e.target === popup) hidePopup();
  });

  // Exit-intent: detect mouse leaving top of viewport
  let exitIntentFired = false;
  document.addEventListener('mouseleave', (e) => {
    if (exitIntentFired) return;
    if (e.clientY > 0) return; // only when cursor leaves from the top
    exitIntentFired = true;
    setTimeout(showPopup, 300);
  });

  // Also show after 60 seconds as a fallback
  setTimeout(() => {
    if (!hasShown && !hasSeenPopup()) showPopup();
  }, 60000);
})();